function digitsOnly(value) {
  return String(value ?? '').replace(/\D/g, '').slice(0, 2);
}

function filterCashItemDayInput(value) {
  const digits = digitsOnly(value);
  if (digits.length < 2) return digits;
  const day = Number(digits);
  if (day === 0) return '0';
  if (day > 31) return digits.slice(0, 1);
  return digits;
}

function commitCashItemDay(value) {
  const digits = digitsOnly(value);
  if (!digits) return '';
  const day = Number(digits);
  if (!Number.isInteger(day) || day < 0 || day > 31) return '';
  if (day === 0) return '0';
  return String(day).padStart(2, '0');
}

function cashItemDayFromSnapshot(item) {
  if (item == null || typeof item !== 'object') return '';
  if (!Object.prototype.hasOwnProperty.call(item, 'date')) return '';
  if (item.date == null || item.date === '') return '';
  return commitCashItemDay(item.date);
}

module.exports = {
  cashItemDayFromSnapshot,
  filterCashItemDayInput,
  commitCashItemDay,
};
